// common/schemas/collections/characters.js
import { z } from "zod";

const CharacterSchema = z.object({
    _id: z.string().optional(),
    subscriptionId: z.string(),
    name: z.string().min(1, "Character name is required."),
    description: z.string().optional().nullable(),
    personalityTraits: z.array(z.string()).optional().default([]),
    visualAppearancePrompt: z.string().min(1, "Visual appearance prompt is required."),
    representativeImageRelativePath: z.string().optional().nullable(),
    assetHash: z.string().optional().nullable().describe("A unique hash for cache-busting the representative image."),
    voice: z.string().optional().nullable().describe("The composite voice ID, e.g., 'JBFqnCBsd6RMkjVDRZzb::eleven_flash_v2_5' or 'alloy::tts-1-hd'"),
    musicThemeRelativePath: z.string().optional().nullable(),
    isDirty: z.boolean().optional().default(false).describe("Set to true if the asset needs regeneration."), // ADD THIS LINE
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default CharacterSchema;